export function galleryPopup() {
    const $body = $("body");
    const popup = $(".gallery-popup");
    const slider = popup.find('.slider');
    const popupOpener = $(".popup-opener");
    const popupClose = $(".popup-close");


    popupOpener.on("click", function (e) {
        e.preventDefault();

        let $this = $(this);
        let target = $this.attr("href");

        $(target).addClass("show");
        $body.addClass("popup-open");

    });
    popupClose.on("click", function (e) {
        e.preventDefault();
        $(this).parents(".popup").removeClass("show").find('.bio-popup-info').remove();
        $body.removeClass("popup-open");
    });

    slider.slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/galleryPopup.js